import React, { useRef, useState } from "react";
import {
  Box,
  useTheme,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Autocomplete,
  Grid,
  Paper,
  FormHelperText,
} from "@mui/material";
import { ViewSchema } from "../../common/ViewSchema/ViewSchema";

import { Typography } from "../../common/Typography/Typography";
import { Button } from "../../common/Button/Button";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { DestinationDownload } from "../../common/Icons/DestinationDownload";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { ApplySchemaTemplateModal } from "./ApplySchemaTemplateModal";
import { SimpleLoader } from "../../common/Loader/Loader";
import { Formik } from "formik";
import * as Yup from "yup";
import { useMutation } from "@apollo/client";
import {
  CreatefinalDataProductGroupDocument,
  FinalDataProductGroupCreationMethod,
} from "../../generated";
import { useParams } from "react-router-dom";
import { CustomTextArea } from "../../common/CustomTextArea/CustomTextArea";
import { CustomTextField } from "../../common/CustomTextField/CustomTextField";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { ViewSelectedSchema } from "../../common/ViewSelectedSchema/ViewSelectedSchema";
import { SnackBar } from "../../common/SnakBar/SnakBar";
import { ButtonPrimary } from "../style";

const inputSchemaData: string | any[] = [
  {
    name: "primary-key-schema-name.json",
    time: "Updated 10/20/2021 at 11:34 AM",
    href: "www.google.com",
  },
];

const reader = new FileReader();

export const CreateDataProductSchemaSetDetails = ({
  toggleRightSidePanel,
  showToast,
}: {
  toggleRightSidePanel: any;
  showToast: any;
}) => {
  const inputFile = useRef<HTMLInputElement>(null);
  const { palette } = useTheme();
  const [toggleSchemaTemplate, setToggleSchemaTemplate] = useState(false);
  const [show, setShow] = useState(false);
  const [success, setSubmitSuccess] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [fileName, setFilename] = useState(null);
  const [isFilePicked, setIsFilePicked] = useState(false);
  const { projectId, workspaceId } = useParams();
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const [create, { loading: creating }] = useMutation(
    CreatefinalDataProductGroupDocument
  );
  reader.onload = (e) => {
    if (reader.result) {
      const annotationsObject = JSON.parse(reader.result as string);
    }
  };

  const onChangeHandler = (event: any) => {
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
    setFilename(event.target.files[0].name);
    if (event.target.files[0]) reader.readAsText(event.target.files[0]);
  };

  return (
    <Formik
      validationSchema={Yup.object().shape({
        name: Yup.string().required(),
        description: Yup.string().required(),
        creationMethod: Yup.string().required(),
        jsonSchema: Yup.string(),
      })}
      initialValues={{
        name: "",
        description: "",
        creationMethod: "NO_SCHEMA",
        jsonSchema: "",
      }}
      onSubmit={async (values) => {
        if (
          values.creationMethod !==
            FinalDataProductGroupCreationMethod.NoSchema &&
          !values.jsonSchema
        )
          return null;

        const input = {
          description: values.description,
          name: values.name,
          projectId: projectId || "",
          workspaceId: workspaceId || "",
          method: values.creationMethod as FinalDataProductGroupCreationMethod,
          ...(values.creationMethod !==
            FinalDataProductGroupCreationMethod.NoSchema &&
            ((values.creationMethod ===
              FinalDataProductGroupCreationMethod.JsonUpload && {
              jsonSchema: values.jsonSchema,
            }) || { targetSchemaId: selectedTemplate?.id || "" })),
        };

        console.log(input);

        await create({
          variables: {
            input: {
              description: values.description,
              name: values.name,
              projectId: projectId || "",
              workspaceId: workspaceId || "",
              method:
                values.creationMethod as FinalDataProductGroupCreationMethod,
              ...(values.creationMethod !==
                FinalDataProductGroupCreationMethod.NoSchema &&
                ((values.creationMethod ===
                  FinalDataProductGroupCreationMethod.JsonUpload && {
                  jsonSchema: values.jsonSchema,
                }) || { targetSchemaId: selectedTemplate?.id || "" })),
            },
          },
          refetchQueries: ["getWorkflow"],
        });

        setSubmitSuccess(true);
        toggleRightSidePanel(false);
        showToast("Data product schema set added");
      }}
    >
      {({
        handleChange,
        errors,
        values,
        touched,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
      }) => {
        reader.onload = (e) => {
          if (reader.result) {
            try {
              const schema = JSON.parse(reader.result as string);

              setFieldValue("jsonSchema", JSON.stringify(schema));
            } catch (e) {
              setFieldTouched("jsonSchema", true, false);
              setFilename(null);
            }
          }
        };
        const setSchema = (selectedTemplete: any) => {
          console.log("setting schema");

          let schemaJson = JSON.parse(selectedTemplete?.jsonSchema);
          setFieldValue("jsonSchema", JSON.stringify(schemaJson));
          setSelectedTemplate(selectedTemplete);
        };
        return (
          <Box
            boxSizing="border-box"
            sx={{
              minHeight: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <SnackBar open={success} message={"Data Product Created"} />
            <Box>
              <Box
                sx={{
                  paddingRight: "20px",
                  paddingBottom: "16px",
                  borderBottom: `1px solid ${palette.outline}`,
                }}
                mb={6}
              >
                <Typography
                  mb={2}
                  variant="h5"
                  color={palette.gray.dark}
                  sx={{
                    fontSize: "12px",
                    lineHeight: "14px",
                    textTransform: "uppercase",
                    fontWeight: "700",
                  }}
                >
                  Data Product
                </Typography>
                <Typography
                  mb={4}
                  variant="h5"
                  color={palette.common.black}
                  sx={{ wordBreak: "break-word" }}
                >
                  New Data Product Group
                </Typography>
              </Box>

              <Box boxSizing="border-box">
                <Box mb={4}>
                  <Box
                    sx={{
                      paddingRight: "20px",
                      paddingBottom: "16px",
                      borderBottom: `1px solid ${palette.outline}`,
                    }}
                    mb={6}
                  >
                    <Typography
                      mb={2}
                      variant="h6"
                      color={palette.common.black}
                      sx={{ fontWeight: "400" }}
                    >
                      Overview
                    </Typography>
                    <Box mb={6} display="flex" flexDirection="column">
                      <Typography
                        variant="body1"
                        mb={2}
                        fontSize="0.875rem"
                        fontWeight={500}
                        color={palette.common.black}
                      >
                        Data product group name
                      </Typography>

                      <CustomTextField
                        name="name"
                        value={values.name}
                        onChange={handleChange}
                        error={errors.name}
                        touched={touched.name}
                      />
                    </Box>
                    <Box mb={6} display="flex" flexDirection="column">
                      <Typography
                        variant="body1"
                        mb={2}
                        fontSize="0.875rem"
                        fontWeight={500}
                        color={palette.common.black}
                      >
                        Description
                      </Typography>

                      <CustomTextArea
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        error={errors.description}
                        touched={touched.description}
                      />
                    </Box>
                  </Box>
                  <Typography
                    mb={2}
                    variant="h6"
                    color={palette.common.black}
                    sx={{ fontWeight: "400" }}
                  >
                    Validation method
                  </Typography>
                  <Typography
                    mb={2}
                    variant="h5"
                    color={palette.gray.darkest}
                    sx={{
                      fontSize: "16px",
                      lineHeight: "24px",
                      fontWeight: "normal",
                    }}
                  >
                    Validate output data products by adding or selecting a
                    target schema.
                  </Typography>
                  <Box mb={3} display="flex" flexDirection="column">
                    <Typography
                      variant="body1"
                      mb={2}
                      fontSize="0.875rem"
                      fontWeight={500}
                      color={palette.common.black}
                    >
                      Method
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name="creationMethod"
                        placeholder="Select target schema validation method"
                        label="Owner"
                        onChange={handleChange}
                        value={values.creationMethod}
                        sx={{
                          fieldset: {
                            top: "0",
                          },
                          legend: {
                            display: "none",
                          },
                          ".MuiInputBase-input": {
                            width: "100%",
                            height: "36px",
                            fontSize: "16px",
                            lineHeight: "20px",
                            padding: "8px",
                            boxSizing: "border-box",
                          },
                        }}
                      >
                        <MenuItem value="NO_SCHEMA">NO SCHEMA</MenuItem>
                        <MenuItem value="SELECT_SCHEMA">Select Schema</MenuItem>
                        <MenuItem value="JSON_UPLOAD" selected>
                          JSON Upload
                        </MenuItem>
                        {/*<MenuItem
                          value={FinalDataProductGroupCreationMethod.JsonUpload}
                        >
                          Upload JSON file
                        </MenuItem>
                        /* <MenuItem
                          value={FinalDataProductGroupCreationMethod.Template}
                        >
                          Template
                        </MenuItem> */}
                      </Select>
                    </FormControl>
                  </Box>
                  {values.creationMethod ===
                    FinalDataProductGroupCreationMethod.SelectSchema &&
                    selectedTemplate !== null && (
                      <ViewSelectedSchema
                        name={selectedTemplate?.name}
                        onDelete={() => {
                          setSelectedTemplate(null);
                        }}
                      />
                    )}
                  {values.creationMethod ===
                  FinalDataProductGroupCreationMethod.JsonUpload ? (
                    <>
                      <Box
                        mb={4}
                        sx={{
                          background: palette.settings.lighter,
                          borderRadius: "4px",
                          padding: "20px",
                        }}
                      >
                        <Typography
                          variant="body1"
                          mb={1}
                          fontSize="0.875rem"
                          fontWeight={400}
                          color={palette.common.black}
                        >
                          Schema source file
                        </Typography>

                        {fileName && <span>{fileName}</span>}
                        <input
                          type="file"
                          id="file"
                          ref={inputFile}
                          style={{ display: "none" }}
                          onChange={onChangeHandler}
                          accept=".json"
                        />
                        <ButtonPrimary
                          color="grayAccent"
                          variant="contained"
                          onClick={() => {
                            inputFile.current?.click();
                          }}
                        >
                          Upload JSON
                        </ButtonPrimary>
                      </Box>
                      {touched.jsonSchema && fileName == null && (
                        <Box
                          display="flex"
                          mt={1}
                          justifyContent="flex-start"
                          alignItems="center"
                        >
                          <ErrorOutlineIcon
                            htmlColor={palette.error.dark}
                            style={{
                              width: "13.33px",
                              height: "13.33px",
                              marginTop: "3px",
                              marginRight: "5px",
                            }}
                          />

                          <FormHelperText
                            style={{
                              color: palette.error.dark,
                              fontFamily: "Roboto",
                              fontSize: "14px",
                              lineHeight: "20px",
                              fontWeight: 400,
                            }}
                          >
                            Please provide valid JSON file
                          </FormHelperText>
                        </Box>
                      )}
                    </>
                  ) : (
                    <>
                      {values.creationMethod ===
                        FinalDataProductGroupCreationMethod.SelectSchema &&
                        selectedTemplate === null && (
                          <Box
                            mb={4}
                            sx={{
                              background: palette.settings.lighter,
                              borderRadius: "4px",
                              padding: "20px",
                            }}
                          >
                            <Typography
                              variant="body1"
                              mb={1}
                              fontSize="0.875rem"
                              fontWeight={400}
                              color={palette.common.black}
                            >
                              Schema
                            </Typography>

                            <Button
                              color="grayAccent"
                              variant="contained"
                              onClick={() => {
                                setToggleSchemaTemplate(true);
                              }}
                            >
                              Select schema
                            </Button>
                          </Box>
                        )}
                      {values.creationMethod ===
                        FinalDataProductGroupCreationMethod.SelectSchema &&
                        selectedTemplate !== null && (
                          <>
                            <ViewSchema
                              name={selectedTemplate?.name}
                              modifiedAt={selectedTemplate?.modifiedAt}
                              jsonSchema={selectedTemplate?.jsonSchema}
                            />

                            <Button
                              color="grayAccent"
                              variant="contained"
                              onClick={(e) => {
                                setToggleSchemaTemplate(true);
                              }}
                              //href={`/workspace/${workspaceId}/project/${projectId}/project-schema/${inputSchemaAsset?.targetSchema?.id}`}
                            >
                              Edit Schema
                            </Button>
                          </>
                        )}
                      {touched.jsonSchema &&
                        values.creationMethod !==
                          FinalDataProductGroupCreationMethod.NoSchema &&
                        selectedTemplate === null && (
                          <Box
                            display="flex"
                            mt={1}
                            justifyContent="flex-start"
                            alignItems="center"
                          >
                            <ErrorOutlineIcon
                              htmlColor={palette.error.dark}
                              style={{
                                width: "13.33px",
                                height: "13.33px",
                                marginTop: "3px",
                                marginRight: "5px",
                              }}
                            />

                            <FormHelperText
                              style={{
                                color: palette.error.dark,
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                lineHeight: "20px",
                                fontWeight: 400,
                              }}
                            >
                              Please choose schema template
                            </FormHelperText>
                          </Box>
                        )}
                    </>
                  )}
                  {show && (
                    <Box
                      mb={4}
                      sx={{
                        background: palette.settings.lighter,
                        borderRadius: "4px",
                        padding: "20px",
                      }}
                    >
                      <Typography
                        variant="body1"
                        mb={1}
                        fontSize="0.875rem"
                        fontWeight={400}
                        color={palette.common.black}
                      >
                        Schema Source File
                      </Typography>

                      <Box sx={{ position: "relative" }}>
                        <ButtonPrimary
                          onClick={inputFile.current?.click}
                          color="grayAccent"
                          variant="outlined"
                        >
                          <svg
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.2771 0.217773C7.82938 0.217773 8.2771 0.665489 8.2771 1.21777C8.2771 1.48299 8.38246 1.73734 8.56999 1.92488C8.75753 2.11242 9.01188 2.21777 9.2771 2.21777C9.82938 2.21777 10.2771 2.66549 10.2771 3.21777C10.2771 3.77006 9.82938 4.21777 9.2771 4.21777C9.01188 4.21777 8.75753 4.32313 8.56999 4.51067C8.38246 4.6982 8.2771 4.95256 8.2771 5.21777C8.2771 5.77006 7.82938 6.21777 7.2771 6.21777C6.72481 6.21777 6.2771 5.77006 6.2771 5.21777C6.2771 4.95256 6.17174 4.6982 5.98421 4.51067C5.79667 4.32313 5.54232 4.21777 5.2771 4.21777C4.72481 4.21777 4.2771 3.77006 4.2771 3.21777C4.2771 2.66549 4.72481 2.21777 5.2771 2.21777C5.54232 2.21777 5.79667 2.11242 5.98421 1.92488C6.17174 1.73734 6.2771 1.48299 6.2771 1.21777C6.2771 0.665489 6.72481 0.217773 7.2771 0.217773ZM15.57 0.510667C15.9605 0.120142 16.5937 0.120142 16.9842 0.510667L19.9842 3.51067C20.3747 3.90119 20.3747 4.53436 19.9842 4.92488L4.98421 19.9249C4.59368 20.3154 3.96052 20.3154 3.56999 19.9249L0.569993 16.9249C0.179469 16.5344 0.179469 15.9012 0.569993 15.5107L12.5698 3.51087L15.57 0.510667ZM13.2771 5.63199L2.69131 16.2178L4.2771 17.8036L14.8629 7.21777L13.2771 5.63199ZM16.2771 5.80356L14.6913 4.21777L16.2771 2.63199L17.8629 4.21777L16.2771 5.80356ZM17.2771 10.2178C17.8294 10.2178 18.2771 10.6655 18.2771 11.2178C18.2771 11.483 18.3825 11.7373 18.57 11.9249C18.7575 12.1124 19.0119 12.2178 19.2771 12.2178C19.8294 12.2178 20.2771 12.6655 20.2771 13.2178C20.2771 13.7701 19.8294 14.2178 19.2771 14.2178C19.0119 14.2178 18.7575 14.3231 18.57 14.5107C18.3825 14.6982 18.2771 14.9526 18.2771 15.2178C18.2771 15.7701 17.8294 16.2178 17.2771 16.2178C16.7248 16.2178 16.2771 15.7701 16.2771 15.2178C16.2771 14.9526 16.1717 14.6982 15.9842 14.5107C15.7967 14.3231 15.5423 14.2178 15.2771 14.2178C14.7248 14.2178 14.2771 13.7701 14.2771 13.2178C14.2771 12.6655 14.7248 12.2178 15.2771 12.2178C15.5423 12.2178 15.7967 12.1124 15.9842 11.9249C16.1717 11.7373 16.2771 11.483 16.2771 11.2178C16.2771 10.6655 16.7248 10.2178 17.2771 10.2178Z"
                              fill={palette.grayAccent.light}
                            />
                          </svg>
                        </ButtonPrimary>
                        <Autocomplete
                          id="schema-template"
                          freeSolo
                          defaultValue={
                            "Dual Enrollment Registered Students" || []
                          }
                          onChange={(_, value) => {}}
                          options={["Template1, Template2, Template3"] || []}
                          renderInput={(params) => <TextField {...params} />}
                          sx={{
                            width: "100%",
                            background: palette.common.white,
                            ".MuiInputBase-input": {
                              width: "100%",
                              height: "36px",
                              fontSize: "16px",
                              lineHeight: "20px",
                              padding: "8px",
                              paddingLeft: "30px !important",
                              boxSizing: "border-box",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                </Box>

                {show && (
                  <Box
                    sx={{
                      paddingBottom: "16px",
                      borderBottom: `1px solid ${palette.outline}`,
                    }}
                    mb={6}
                  >
                    <Box>
                      <Typography
                        mb={4}
                        variant="h5"
                        color={palette.common.black}
                        sx={{
                          fontSize: "18px",
                          lineHeight: "24px",
                          fontWeight: "normal",
                        }}
                      >
                        Input target schema
                      </Typography>

                      <Box
                        mb={4}
                        sx={{
                          background: palette.settings.lighter,
                          borderRadius: "4px",
                          padding: "20px",
                          "> .MuiBox-root": {
                            width: "100%",
                          },
                        }}
                      >
                        <SimpleLoader
                          text="Generating input target schema..."
                          className="custom-loader"
                          customTextClass="custom-text"
                        />
                      </Box>

                      <Box>
                        <Grid container>
                          {inputSchemaData && inputSchemaData.length > 0 ? (
                            <>
                              {inputSchemaData.map((product) => (
                                <Grid
                                  item
                                  xs={12}
                                  mb={4}
                                  sx={{ minWidth: "360px" }}
                                >
                                  <Paper
                                    variant="outlined"
                                    sx={{
                                      p: 4,
                                      display: "flex",
                                      minHeight: "100%",
                                      boxSizing: "border-box",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Box display="flex">
                                      <Box
                                        mr={3}
                                        width="2rem"
                                        sx={{
                                          ".MuiSvgIcon-root": {
                                            minWidth: "2rem",
                                            width: "2rem",
                                            height: "2rem",
                                            path: {
                                              fill: palette.grayAccent.light,
                                            },
                                          },
                                        }}
                                      >
                                        <DestinationDownload />
                                      </Box>

                                      <Box sx={{ paddingLeft: 3 }}>
                                        <Typography
                                          variant="subtitle2"
                                          color={palette.common.black}
                                          sx={{
                                            fontSize: "0.875rem",
                                            fontWeight: 500,
                                          }}
                                        >
                                          {product?.name}
                                        </Typography>
                                        <Typography
                                          variant="subtitle2"
                                          color={palette.gray.darkest}
                                          sx={{
                                            fontSize: "12px",
                                            fontWeight: 400,
                                          }}
                                        >
                                          {product?.time}
                                        </Typography>
                                      </Box>
                                    </Box>
                                    <Button
                                      color="primary"
                                      variant="contained"
                                      onClick={() =>
                                        window.open(
                                          product?.href || "#",
                                          "_blank"
                                        )
                                      }
                                      endIcon={
                                        <FileDownloadOutlinedIcon fontSize="small" />
                                      }
                                      sx={{
                                        ".MuiSvgIcon-root": {
                                          fontSize: "1.5rem !important",
                                        },
                                      }}
                                    ></Button>
                                  </Paper>
                                </Grid>
                              ))}
                              <Button color="grayAccent" variant="contained">
                                Edit Schema
                              </Button>
                            </>
                          ) : (
                            <Typography
                              mb={2}
                              variant="h5"
                              color={palette.error.dark}
                              sx={{
                                fontSize: "14px",
                                lineHeight: "20px",
                                fontWeight: "400",
                              }}
                            >
                              <InfoOutlinedIcon
                                sx={{
                                  fontSize: "16px",
                                  lineHeight: "20px",
                                  display: "inline-block",
                                  verticalAlign: "middle",
                                  marginRight: "3px",
                                  marginBottom: "3px",
                                  color: palette.error.dark,
                                }}
                              />
                              No schema defined
                            </Typography>
                          )}
                        </Grid>
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>

            {toggleSchemaTemplate && (
              <ApplySchemaTemplateModal
                selectedTemplate={selectedTemplate}
                setToggleSchemaTemplate={setToggleSchemaTemplate}
                setSchema={setSchema}
              />
            )}
            <Box>
              <Button
                color="primary"
                variant="contained"
                sx={{ width: "100%", marginBottom: "10px" }}
                onClick={(e) => handleSubmit()}
              >
                Save
              </Button>
              <Button
                color="grayAccent"
                variant="outlined"
                sx={{ width: "100%" }}
                onClick={toggleRightSidePanel}
                disabled={creating}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        );
      }}
    </Formik>
  );
};
